<template>
		<div>
			<b-form-group label="Etiquetas:">
				<multiselect
				v-model="tags"
				:options="tagsOpts"
				multiple
				label="text"
				track-by="id"
				placeholder="Todos"
				size="xs"
				taggable
				tag-placeholder="Agregar esta etiqueta a la lista"
				@tag="addItem"
				:show-labels="false"
				:disabled="unableEdit"
				>
					<template v-slot:clear >
						<div class="multiselect__clear" @click="tags = []"></div>
					</template>

					<template slot="option" slot-scope="props">
						<span>{{ props.option.text}} </span>
						<b-button
						@click="deleteItem($event,props)"
						variant="danger"
						size="sm"
						class="float-right"
						title="Eliminar esta etiqueta de los registros"
						v-if="$hasPermission('reservation.adminTags')"
						>
							<md-icon :icon="'delete'"/></b-button>
					</template>

				</multiselect>
			</b-form-group>
		</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapFields } from "../helpers/helpers";
export default {
	props:{
		index: Number,
		unableEdit: Boolean,
	},
	data(){
		return {
		}
	},
	components: {
		Multiselect
	},
	methods:{
		addItem(newElement){
			if(!this.$hasPermission('reservation.adminTags')){
				this.$root.showAlert("Accion denegada, permisos insuficientes.",{variant:"warning"});
				return;
			}
			this.$root.api.post("/tags",{tag:newElement}).
			then((res)=>{
				let el      = {value:res.data.id,text:res.data.text};//se agrega el array global
				let elValue = {id:res.data.id,text:res.data.text};//se seleccionaa
				this.$root.auxVars.tagsOpts.push(el)
				this.tags.push(elValue);
				this.$root.showAlert("Se agregó correctamente la etiqueta");
			})
			.catch(this.$root.handleRequestError)
		},
		deleteItem(event,props){
			event.preventDefault();
			event.stopPropagation()
			let idTag = props.option.id;
			this.$bvModal.msgBoxConfirm('¿Esta seguro que desea ELIMINAR el registro de manera permanente? Ya no se podrá usar en ningun otro ride', {
				title: 'Confirmación eliminación Etiqueta: '+props.option.text,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'SI, Eliminar!',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false
			})
			.then(value => {
				if(!value) return false;
				this.$root.api.delete("/tags/"+idTag)
				.then(()=>{
					let forceRefresh = true;
					this.$root.auxVars.loadResourcesOpts({
						vm: this,
						resourceNames: [
							"tagsOpts"
						],
						forceRefresh
					});
				})
				.catch(this.$root.handleRequestError)
			})
			.catch(err => {
				console.log(err)
			})
		}
	},
	beforeCreate() {
		this.$options.computed = {
			...mapFields({
				fields: [
					"tags",
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			tagsOpts(){
				return this.$root.auxVars.tagsOpts.map((item)=>{
					return {id:item.value,text:item.text};
				})
			},
			viewModel(){
				return this.$store.state.reservation.viewModel
			}
		};
	},
	mounted(){
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"tagsOpts"
			]
		});
	},
};
</script>
